import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3824078a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([this.category.length === 2 ? 'sort-menu-2' : 'sort-menu'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category, (item, index) => {
      return (_openBlock(), _createElementBlock("nav", { key: item }, [
        _createElementVNode("button", {
          id: index,
          class: _normalizeClass(this.chooseDisplay(index)),
          onClick: ($event: any) => (this.activeButton(index))
        }, _toDisplayString(item), 11, _hoisted_1)
      ]))
    }), 128))
  ], 2))
}